var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user__global__alert global__alert" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: {
            ok: function($event) {
              return _vm.deleteAlert(_vm.deleteAlertId)
            }
          },
          model: {
            value: _vm.confirmDeleteAlert,
            callback: function($$v) {
              _vm.confirmDeleteAlert = $$v
            },
            expression: "confirmDeleteAlert"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this alert?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-global-alert-detail",
          attrs: { size: "lg", "hide-footer": "", id: "userGlobalAlertDetail" }
        },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.alertTitle) + "\n            "
            ),
            _c("p", { staticClass: "notification-sender" }, [
              _vm._v(
                "\n                sent by " +
                  _vm._s(_vm.alertSender) +
                  " @ " +
                  _vm._s(_vm.getLocalAlertTime(_vm.alertTime)) +
                  "\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.alertDetail) } })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "viewTitleModal",
            title: "Enter View Title"
          }
        },
        [
          _c("ViewTitleModal", {
            ref: "refViewTitleModal",
            on: { setActiveView: _vm.setActiveView }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "viewTitleUpdateModal",
            title: "Enter View Title"
          }
        },
        [
          _c("ViewTitleModal", {
            ref: "refViewTitleModal",
            attrs: { title: _vm.viewBtnLabel, viewId: _vm.activeView },
            on: { setActiveView: _vm.setActiveView }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            id: "headerViewSelectModal",
            "hide-footer": "",
            title: "Views"
          },
          on: { hidden: _vm.viewSelectModalHidden }
        },
        [
          _c(
            "div",
            {
              staticClass: "saved-views",
              attrs: { id: "header-view-select-modal" }
            },
            [
              _c(
                "div",
                { staticClass: "view-select-title-header" },
                [
                  _c("h4", [_vm._v("Views")]),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "d-block",
                      attrs: {
                        variant: "theme",
                        title: "Close View Popup",
                        size: "sm"
                      },
                      on: { click: _vm.closeViewSelectModal }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "view-select-body" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeView != "-1",
                        expression: "activeView != '-1'"
                      }
                    ],
                    staticClass: "dropdown-item clear-view",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        _vm.handleResetFilter()
                        _vm.$bvModal.hide("headerViewSelectModal")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    Clear View\n                    "
                    ),
                    _c("span", { staticClass: "float-right" }, [
                      _c("i", { staticClass: "fas fa-cross text-primary" })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.viewModalShowUpdateView,
                        expression: "viewModalShowUpdateView"
                      }
                    ],
                    staticClass: "dropdown-item update-view",
                    attrs: { href: "#" },
                    on: { click: _vm.modalUpdateView }
                  },
                  [
                    _vm._v(
                      "\n                    Update View\n                    "
                    ),
                    _c("span", { staticClass: "float-right" }, [
                      _c("i", { staticClass: "far fa-edit text-primary" })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.viewModalShowCreateView,
                        expression: "viewModalShowCreateView"
                      }
                    ],
                    staticClass: "dropdown-item save-view",
                    attrs: { href: "#" },
                    on: { click: _vm.modalSaveView }
                  },
                  [
                    _vm._v(
                      "\n                    Save View\n                    "
                    ),
                    _c("span", { staticClass: "float-right" }, [
                      _c("i", {
                        staticClass: "fas fa-plus-circle text-primary"
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showNewViewTitleArea
                  ? _c(
                      "div",
                      { staticClass: "new-view-title-area" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("h5", [_vm._v("Save View")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ViewTitleModal", {
                          attrs: { hasCancelButton: true },
                          on: {
                            setActiveView: _vm.setActiveView,
                            cancelEdit: function($event) {
                              _vm.showNewViewTitleArea = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showUpdateViewTitleArea
                  ? _c(
                      "div",
                      { staticClass: "update-view-title-area" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("h5", [_vm._v("Update View")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ViewTitleModal", {
                          attrs: {
                            title: _vm.viewBtnLabel,
                            viewId: _vm.activeView,
                            hasCancelButton: true
                          },
                          on: {
                            setActiveView: _vm.setActiveView,
                            cancelEdit: function($event) {
                              _vm.showUpdateViewTitleArea = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showNewViewTitleArea && !_vm.showUpdateViewTitleArea
                  ? _c(
                      "div",
                      { ref: "views__scroll", staticClass: "views__scroll" },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              scroll__view__btns:
                                !_vm.viewModalShowCreateView &&
                                !_vm.viewModalShowUpdateView
                            }
                          },
                          [
                            _vm._l(_vm.presetViewsNotification, function(
                              userView,
                              index
                            ) {
                              return _c(
                                "a",
                                {
                                  key:
                                    "notificationPresetView" +
                                    index +
                                    1 * Math.random(),
                                  staticClass: "dropdown-item",
                                  class: {
                                    active: _vm.activeView == userView.id
                                  },
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.loadViewFromModal(userView)
                                    }
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "preset-icon-wrap"
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "save-title" }, [
                                    _vm._v(_vm._s(userView.title))
                                  ])
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.notificationViews, function(
                              userView,
                              index
                            ) {
                              return _c(
                                "a",
                                {
                                  key:
                                    "notificationView" +
                                    index +
                                    1 * Math.random(),
                                  staticClass: "dropdown-item",
                                  class: {
                                    active: _vm.activeView == userView.id
                                  },
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.loadViewFromModal(userView)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "remove-icon-wrap" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "remove-icon",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.removeView(userView.id)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-trash"
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "save-title" }, [
                                    _vm._v(_vm._s(userView.title))
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("HeaderControls", {
        ref: "headerControls",
        attrs: {
          namespace: _vm.namespace,
          availableFilters: _vm.availableFilters
        },
        on: { "filter-change": _vm.handleFilterChange }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "fixed-top-bar-padding" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "deliverable-header" }, [
            _c("h2", [
              _c("div", [
                _vm._m(0),
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.headerText) +
                    "\n                    "
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "d-inline-block saved-views-area pt-15",
                  class: [_vm.activeView != "-1" ? "saved-view-active" : ""]
                },
                [
                  typeof _vm.userAlerts.data != "undefined" &&
                  _vm.userAlerts.data.length > 0
                    ? _c(
                        "b-button",
                        {
                          staticClass: "btn btn-theme",
                          attrs: { variant: "theme" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.makeAllFilteredAlertsRead.apply(
                                null,
                                arguments
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.markAllButtonLabel) +
                              "\n                            "
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.runningTask,
                                  expression: "runningTask"
                                }
                              ],
                              staticClass:
                                "ml-2 spinner-border spinner-border-sm text-primary",
                              attrs: { role: "status" }
                            },
                            [
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v("Marking...")
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "btn-group ml-2 add-new__global_search sorting saved-views d-none d-md-inline-flex"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-theme header-filter-btns dropdown-toggle",
                          attrs: {
                            type: "button",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false"
                          },
                          on: { click: _vm.updatePerfectScroll }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mr-3 view__label truncate-text" },
                            [_vm._v(_vm._s(_vm.viewBtnLabel))]
                          ),
                          _vm._v(" "),
                          _vm.activeView == "-1"
                            ? _c("i", {
                                staticClass:
                                  "fas fa-fw fa-eye text-primary float-right"
                              })
                            : _c("i", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    value: {
                                      customClass: "save__view__tooltip"
                                    },
                                    expression:
                                      "{customClass: 'save__view__tooltip'}",
                                    modifiers: { hover: true }
                                  }
                                ],
                                staticClass:
                                  "fas fa-fw fa-eye text-primary float-right",
                                attrs: { title: "Clear View" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.handleResetFilter.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu viewmenu-dropdown" },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.viewModalShowUpdateView,
                                      expression: "viewModalShowUpdateView"
                                    }
                                  ],
                                  staticClass: "dropdown-item update-view",
                                  attrs: { href: "#" },
                                  on: { click: _vm.updateView }
                                },
                                [
                                  _vm._v(
                                    "\n                                        Update View\n                                        "
                                  ),
                                  _vm._m(1)
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item save-view",
                                  attrs: { href: "#" },
                                  on: { click: _vm.saveView }
                                },
                                [
                                  _vm._v(
                                    "\n                                        Save View\n                                        "
                                  ),
                                  _vm._m(2)
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "perfect-scrollbar",
                                {
                                  ref: "views__scroll",
                                  staticClass: "views__scroll"
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _vm._l(
                                        _vm.presetViewsNotification,
                                        function(userView, index) {
                                          return _c(
                                            "a",
                                            {
                                              key:
                                                "notificationPresetViewDD" +
                                                index +
                                                1 * Math.random(),
                                              staticClass: "dropdown-item",
                                              class: {
                                                active:
                                                  _vm.activeView == userView.id
                                              },
                                              attrs: { href: "#" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.loadView(userView)
                                                }
                                              }
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "preset-icon-wrap"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "save-title" },
                                                [_vm._v(_vm._s(userView.title))]
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.notificationViews, function(
                                        userView,
                                        index
                                      ) {
                                        return _c(
                                          "a",
                                          {
                                            key:
                                              "notificationViewDD" +
                                              index +
                                              1 * Math.random(),
                                            staticClass: "dropdown-item",
                                            class: {
                                              active:
                                                _vm.activeView == userView.id
                                            },
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                return _vm.loadView(userView)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "remove-icon-wrap"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "remove-icon",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.removeView(
                                                          userView.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-trash"
                                                    })
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "save-title" },
                                              [_vm._v(_vm._s(userView.title))]
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.headerViewSelectModal",
                          modifiers: { headerViewSelectModal: true }
                        }
                      ],
                      staticClass: "btn btn-theme ml-2 d-md-none",
                      attrs: { variant: "theme" }
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.viewBtnLabel) +
                          "\n                            "
                      ),
                      _c("i", { staticClass: "fas text-primary fa-eye fa-fw" })
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "global-alerts-status" }, [
            typeof _vm.userAlerts.data != "undefined" &&
            _vm.userAlerts.data.length == 0 &&
            _vm.getUnreadGlobalAlerts().length == 0
              ? _c("span", [_c("h2", [_vm._v("You have no notifications.")])])
              : _vm._e(),
            _vm._v(" "),
            _vm.getUnreadGlobalAlerts().length
              ? _c("div", { staticClass: "global-alerts-top mb-4" }, [
                  _vm.currentFilters.group_by === "deliverable" ||
                  _vm.currentFilters.group_by === "project"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "mb-4 notification-group-block important-notification-block"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-row dbox-wrapper" },
                            [
                              _c(
                                "div",
                                { staticClass: "w-100 dbox-left-side" },
                                [
                                  _c("div", { staticClass: "top-row" }, [
                                    _vm._m(3),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "data-items w-100" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "notification-preview",
                                            attrs: {
                                              id:
                                                "notification-alert-" +
                                                _vm.getUnreadGlobalAlerts()[0]
                                                  .id
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover",
                                                    modifiers: { hover: true }
                                                  }
                                                ],
                                                staticClass:
                                                  "notification-icon-wrapper cursor-pointer",
                                                attrs: {
                                                  title: "Mark as read"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.markAlertReadOnly(
                                                      _vm.getUnreadGlobalAlerts()[0]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "notification-icon",
                                                  attrs: {
                                                    src: require("@/csmworkflow/img/bell-regular.svg")
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "details cursor-pointer",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.setAlert(
                                                      _vm.getUnreadGlobalAlerts()[0]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "alert__name cursor-pointer fw-bold"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getUnreadGlobalAlerts()[0]
                                                          .title
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "notification-sender"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "fw-bold"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getUnreadGlobalAlerts()[0]
                                                              .sender
                                                          ) +
                                                            " @ " +
                                                            _vm._s(
                                                              _vm.getLocalAlertTime(
                                                                _vm.getUnreadGlobalAlerts()[0]
                                                                  .created_at
                                                              )
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "note-message",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.processMessage(
                                                        _vm.getUnreadGlobalAlerts()[0]
                                                          .message
                                                      )
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "ml-auto pr-2" },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "btn btn-theme",
                                                    attrs: {
                                                      size: "sm",
                                                      variant: "theme"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.markSingleAlertRead(
                                                          _vm.getUnreadGlobalAlerts()[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    Mark as Read\n                                                "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.getUnreadGlobalAlerts().length > 1
                                    ? _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "list-unstyled notification-list-single-column"
                                        },
                                        _vm._l(
                                          _vm.getUnreadGlobalAlerts().slice(1),
                                          function(alert) {
                                            return _c(
                                              "li",
                                              {
                                                key:
                                                  "important-group-" + alert.id,
                                                staticClass:
                                                  "group-alert-item notification-single-row unread-notification",
                                                attrs: {
                                                  id:
                                                    "notification-alert-" +
                                                    alert.id
                                                }
                                              },
                                              [
                                                _c("div", {
                                                  staticClass: "placeholder-n"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "notification-info-wrapper"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "b-tooltip",
                                                            rawName:
                                                              "v-b-tooltip.hover",
                                                            modifiers: {
                                                              hover: true
                                                            }
                                                          }
                                                        ],
                                                        staticClass:
                                                          "notification-icon-wrapper cursor-pointer",
                                                        attrs: {
                                                          title: "Mark as read"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.markAlertReadOnly(
                                                              alert
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass:
                                                            "notification-icon",
                                                          attrs: {
                                                            src: require("@/csmworkflow/img/bell-regular.svg")
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "details cursor-pointer",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.setAlert(
                                                              alert
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "alert__name cursor-pointer fw-bold"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                alert.title
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "notification-sender"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "fw-bold"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    alert.sender
                                                                  ) +
                                                                    " @ " +
                                                                    _vm._s(
                                                                      _vm.getLocalAlertTime(
                                                                        alert.created_at
                                                                      )
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "note-message",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.processMessage(
                                                                alert.message
                                                              )
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ml-auto pr-2"
                                                      },
                                                      [
                                                        _c(
                                                          "b-button",
                                                          {
                                                            staticClass:
                                                              "btn btn-theme",
                                                            attrs: {
                                                              size: "sm",
                                                              variant: "theme"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.markSingleAlertRead(
                                                                  alert
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                    Mark as Read\n                                                "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _c("div", [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("div", { staticClass: "global-alerts-section" }, [
                          _c(
                            "ul",
                            {
                              staticClass: "list-unstyled no-grouping-list mb-0"
                            },
                            _vm._l(_vm.getUnreadGlobalAlerts(), function(
                              alert
                            ) {
                              return _c(
                                "li",
                                {
                                  key: "important-top-" + alert.id,
                                  staticClass:
                                    "no-group-alert-item notification-single-row unread-notification",
                                  attrs: {
                                    id: "notification-alert-" + alert.id
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "notification-info-wrapper"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true }
                                            }
                                          ],
                                          staticClass:
                                            "notification-icon-wrapper cursor-pointer",
                                          attrs: { title: "Mark as read" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.markAlertReadOnly(
                                                alert
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "notification-icon",
                                            attrs: {
                                              src: require("@/csmworkflow/img/bell-regular.svg")
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true }
                                            }
                                          ],
                                          staticClass: "details cursor-pointer",
                                          attrs: { title: "View detail" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.setAlert(alert)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "alert__name cursor-pointer fw-bold"
                                            },
                                            [_vm._v(_vm._s(alert.title))]
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "notification-sender"
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "fw-bold" },
                                                [
                                                  _vm._v(
                                                    _vm._s(alert.sender) +
                                                      " @ " +
                                                      _vm._s(
                                                        _vm.getLocalAlertTime(
                                                          alert.created_at
                                                        )
                                                      )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "note-message",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.processMessage(
                                                  alert.message
                                                )
                                              )
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "ml-auto pr-2" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "btn btn-theme",
                                              attrs: {
                                                size: "sm",
                                                variant: "theme"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.markSingleAlertRead(
                                                    alert
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                Mark as Read\n                                            "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentFilters.group_by &&
            _vm.currentFilters.group_by !== "none"
              ? _c(
                  "div",
                  { staticClass: "alert-item clearfix" },
                  _vm._l(_vm.visibleGroupedAlerts, function(group, groupKey) {
                    return _c(
                      "div",
                      {
                        key: "group-" + groupKey,
                        staticClass: "mb-4",
                        class: [
                          "notification-group-collapsible-" + groupKey,
                          {
                            "notification-group-block":
                              _vm.currentFilters.group_by !== "date"
                          }
                        ]
                      },
                      [
                        _vm.currentFilters.group_by !== "date"
                          ? _c(
                              "div",
                              { staticClass: "d-flex flex-row dbox-wrapper" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "w-100 dbox-left-side" },
                                  [
                                    _c("div", { staticClass: "top-row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "data-items group-title"
                                        },
                                        [
                                          _c(
                                            "h3",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true }
                                                }
                                              ],
                                              staticClass:
                                                "group-header-title mb-0",
                                              style: {
                                                cursor:
                                                  _vm.currentFilters
                                                    .group_by ===
                                                    "deliverable" &&
                                                  !_vm.canOpenDeliverableGroup(
                                                    groupKey
                                                  )
                                                    ? "default"
                                                    : "pointer"
                                              },
                                              attrs: {
                                                title:
                                                  _vm.currentFilters
                                                    .group_by ===
                                                    "deliverable" &&
                                                  _vm.getGroupMeta(groupKey) &&
                                                  (_vm.getGroupMeta(groupKey)
                                                    .deleted ||
                                                    _vm.getGroupMeta(groupKey)
                                                      .project_deleted)
                                                    ? "Deliverable/Project deleted"
                                                    : "Open"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  _vm.currentFilters
                                                    .group_by ===
                                                    "deliverable" &&
                                                  !_vm.canOpenDeliverableGroup(
                                                    groupKey
                                                  )
                                                    ? null
                                                    : _vm.goToDetailPage(
                                                        groupKey
                                                      )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    (_vm.getGroupMeta(
                                                      groupKey
                                                    ) &&
                                                      _vm.getGroupMeta(groupKey)
                                                        .title) ||
                                                      groupKey
                                                  ) +
                                                  "\n                                            "
                                              ),
                                              _vm.currentFilters.group_by ===
                                                "deliverable" &&
                                              _vm.getGroupMeta(groupKey) &&
                                              _vm.getGroupMeta(groupKey)
                                                .project_title
                                                ? _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "d-block text-muted",
                                                      staticStyle: {
                                                        "font-size": "0.75rem",
                                                        "font-weight": "normal"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            _vm.getGroupMeta(
                                                              groupKey
                                                            ).project_title
                                                          ) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "data-items" }, [
                                        _vm.currentFilters.group_by ===
                                        "project"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "read-notification"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "notification-info-wrapper fw-bold"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "details mb-0"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProjectGroupDeliverableCount(
                                                                groupKey
                                                              )
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          " deliverables\n                                                    "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-muted px-1"
                                                          },
                                                          [_vm._v("•")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getGroupUnreadTotal(
                                                                groupKey
                                                              )
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          " unread notifications\n                                                "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm.getGroupAlerts(groupKey)
                                              .length > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "notification-preview",
                                                class:
                                                  _vm.getGroupAlerts(
                                                    groupKey
                                                  )[0].status == 0
                                                    ? ""
                                                    : "read-notification",
                                                attrs: {
                                                  id:
                                                    "notification-alert-" +
                                                    _vm.getGroupAlerts(
                                                      groupKey
                                                    )[0].id
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "notification-icon-wrapper cursor-pointer",
                                                    attrs: {
                                                      title:
                                                        _vm.getGroupAlerts(
                                                          groupKey
                                                        )[0].status == 0
                                                          ? "Mark as read"
                                                          : "Read"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.markAlertReadOnly(
                                                          _vm.getGroupAlerts(
                                                            groupKey
                                                          )[0],
                                                          groupKey,
                                                          { isTopRow: true }
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm.currentFilters
                                                      .group_by ===
                                                      "deliverable" ||
                                                    (_vm.currentFilters
                                                      .group_by === "project" &&
                                                      _vm.getGroupAlerts(
                                                        groupKey
                                                      )[0].deliverable_group_id)
                                                      ? _c("img", {
                                                          staticClass:
                                                            "notification-icon",
                                                          attrs: {
                                                            src: _vm.getDeliverableIconSrc(
                                                              _vm.getGroupAlerts(
                                                                groupKey
                                                              )[0].status
                                                            )
                                                          }
                                                        })
                                                      : _vm.currentFilters
                                                          .group_by ===
                                                        "global_alert"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "notification-icon",
                                                          attrs: {
                                                            src: require("@/csmworkflow/img/bell-regular.svg")
                                                          }
                                                        })
                                                      : _vm.currentFilters
                                                          .group_by ===
                                                        "project"
                                                      ? _c("i", {
                                                          class: [
                                                            "fas",
                                                            "fa-folder",
                                                            "fa-fw",
                                                            "notification-icon-fa"
                                                          ],
                                                          style: {
                                                            color: _vm.getProjectIconColor(
                                                              _vm.getGroupAlerts(
                                                                groupKey
                                                              )[0].status
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "details cursor-pointer",
                                                    attrs: {
                                                      title: "View detail"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.setAlert(
                                                          _vm.getGroupAlerts(
                                                            groupKey
                                                          )[0],
                                                          groupKey,
                                                          { isTopRow: true }
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "alert__name cursor-pointer fw-bold"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getGroupAlerts(
                                                              groupKey
                                                            )[0].title
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "notification-sender"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "fw-bold"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getGroupAlerts(
                                                                  groupKey
                                                                )[0].sender
                                                              ) +
                                                                " @ " +
                                                                _vm._s(
                                                                  _vm.getLocalAlertTime(
                                                                    _vm.getGroupAlerts(
                                                                      groupKey
                                                                    )[0]
                                                                      .created_at
                                                                  )
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "note-message",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.processMessage(
                                                            _vm.getGroupAlerts(
                                                              groupKey
                                                            )[0].message
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "data-items ml-auto" },
                                        [
                                          _vm.showGroupMarkButton(groupKey)
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass: "btn btn-theme",
                                                  attrs: { variant: "theme" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.makeGroupAlertsRead(
                                                        groupKey
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            Mark All as Read\n                                        "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-collapse",
                                      {
                                        attrs: {
                                          id:
                                            "notification-group-collapse-" +
                                            groupKey
                                        }
                                      },
                                      [
                                        _vm.currentFilters.group_by ===
                                        "project"
                                          ? _c(
                                              "div",
                                              [
                                                _vm.getProjectSectionAlerts(
                                                  groupKey
                                                ).length
                                                  ? _c(
                                                      "ul",
                                                      {
                                                        staticClass:
                                                          "list-unstyled notification-list-single-column project-section-list"
                                                      },
                                                      [
                                                        _c(
                                                          "li",
                                                          {
                                                            key:
                                                              "project-section-header-" +
                                                              groupKey,
                                                            staticClass:
                                                              "group-alert-item notification-single-row project-section-header",
                                                            class: _vm.projectSectionHasUnread(
                                                              groupKey
                                                            )
                                                              ? "unread-notification"
                                                              : "read-notification"
                                                          },
                                                          [
                                                            _c("div", {
                                                              staticClass:
                                                                "placeholder-n"
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "notification-info-wrapper"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "b-tooltip",
                                                                        rawName:
                                                                          "v-b-tooltip.hover",
                                                                        modifiers: {
                                                                          hover: true
                                                                        }
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "notification-icon-wrapper cursor-pointer",
                                                                    class: _vm.projectSectionHasUnread(
                                                                      groupKey
                                                                    )
                                                                      ? "cursor-pointer"
                                                                      : "pointer-default",
                                                                    attrs: {
                                                                      title: _vm.getMarkAllProjectSectionTooltip(
                                                                        groupKey
                                                                      )
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        _vm.projectSectionHasUnread(
                                                                          groupKey
                                                                        )
                                                                          ? _vm.markAllProjectLevelNotifsRead(
                                                                              groupKey
                                                                            )
                                                                          : null
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      class: [
                                                                        "fas",
                                                                        "fa-folder",
                                                                        "fa-fw",
                                                                        "notification-icon-fa"
                                                                      ],
                                                                      style: {
                                                                        color: _vm.getProjectIconColor(
                                                                          _vm.projectSectionHasUnread(
                                                                            groupKey
                                                                          )
                                                                            ? 0
                                                                            : 1
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _vm.projectSectionHasUnread(
                                                                  groupKey
                                                                )
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "alert-status"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "b-tooltip",
                                                                                rawName:
                                                                                  "v-b-tooltip.hover",
                                                                                modifiers: {
                                                                                  hover: true
                                                                                }
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "fas fa-circle text-primary",
                                                                            attrs: {
                                                                              title:
                                                                                "Unread"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "b-tooltip",
                                                                        rawName:
                                                                          "v-b-tooltip.hover",
                                                                        modifiers: {
                                                                          hover: true
                                                                        }
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "details cursor-pointer",
                                                                    attrs: {
                                                                      title:
                                                                        "Open project"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.goToDetailPage(
                                                                          groupKey
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "alert__name cursor-pointer"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                            " +
                                                                            _vm._s(
                                                                              (_vm.getGroupMeta(
                                                                                groupKey
                                                                              ) &&
                                                                                _vm.getGroupMeta(
                                                                                  groupKey
                                                                                )
                                                                                  .title) ||
                                                                                groupKey
                                                                            ) +
                                                                            "\n                                                        "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.getProjectSectionVisibleAlerts(
                                                            groupKey
                                                          ),
                                                          function(alert) {
                                                            return _c(
                                                              "li",
                                                              {
                                                                key:
                                                                  "project-alert-" +
                                                                  alert.id,
                                                                staticClass:
                                                                  "group-alert-item notification-single-row",
                                                                class:
                                                                  alert.status ==
                                                                  0
                                                                    ? "unread-notification"
                                                                    : "read-notification",
                                                                attrs: {
                                                                  id:
                                                                    "notification-alert-" +
                                                                    alert.id
                                                                }
                                                              },
                                                              [
                                                                _c("div", {
                                                                  staticClass:
                                                                    "placeholder-n"
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "notification-info-wrapper"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "b-tooltip",
                                                                            rawName:
                                                                              "v-b-tooltip.hover",
                                                                            modifiers: {
                                                                              hover: true
                                                                            }
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "notification-icon-wrapper cursor-pointer",
                                                                        attrs: {
                                                                          title:
                                                                            alert.status ==
                                                                            0
                                                                              ? "Mark as read"
                                                                              : "Read"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.markAlertReadOnly(
                                                                              alert,
                                                                              groupKey
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            class: [
                                                                              "fas",
                                                                              "fa-folder",
                                                                              "fa-fw",
                                                                              "notification-icon-fa"
                                                                            ],
                                                                            style: {
                                                                              color: _vm.getProjectIconColor(
                                                                                alert.status
                                                                              )
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    alert.status ==
                                                                    0
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "alert-status"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "b-tooltip",
                                                                                    rawName:
                                                                                      "v-b-tooltip.hover",
                                                                                    modifiers: {
                                                                                      hover: true
                                                                                    }
                                                                                  }
                                                                                ],
                                                                                staticClass:
                                                                                  "fas fa-circle",
                                                                                class:
                                                                                  alert.status ==
                                                                                  0
                                                                                    ? "text-primary"
                                                                                    : "text-primary",
                                                                                attrs: {
                                                                                  title:
                                                                                    alert.status ==
                                                                                    0
                                                                                      ? "Unread"
                                                                                      : "Read"
                                                                                }
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "b-tooltip",
                                                                            rawName:
                                                                              "v-b-tooltip.hover",
                                                                            modifiers: {
                                                                              hover: true
                                                                            }
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "details cursor-pointer",
                                                                        attrs: {
                                                                          title:
                                                                            "View detail"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.setAlert(
                                                                              alert,
                                                                              groupKey
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "alert__name cursor-pointer fw-bold"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                alert.title
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "br"
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "notification-sender"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "fw-bold"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    alert.sender
                                                                                  ) +
                                                                                    " @ " +
                                                                                    _vm._s(
                                                                                      _vm.getLocalAlertTime(
                                                                                        alert.created_at
                                                                                      )
                                                                                    )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "br"
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "note-message",
                                                                            domProps: {
                                                                              innerHTML: _vm._s(
                                                                                _vm.processMessage(
                                                                                  alert.message
                                                                                )
                                                                              )
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.getProjectSectionTotal(
                                                  groupKey
                                                ) > 5 &&
                                                _vm.projectSectionHasMoreToShow(
                                                  groupKey
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-center py-3"
                                                      },
                                                      [
                                                        _c(
                                                          "b-button",
                                                          {
                                                            staticClass:
                                                              "load-more-btn",
                                                            attrs: {
                                                              variant:
                                                                "outline-secondary",
                                                              size: "sm",
                                                              disabled:
                                                                _vm
                                                                  .groupLoadingMore[
                                                                  groupKey
                                                                ]
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.loadMoreProjectSection(
                                                                  groupKey
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm
                                                              .groupLoadingMore[
                                                              groupKey
                                                            ]
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "\n                                                    Loading...\n                                                "
                                                                  )
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    "\n                                                    Load More\n                                                "
                                                                  )
                                                                ])
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.getProjectSubgroups(
                                                    groupKey
                                                  ),
                                                  function(subGroup) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key:
                                                          "project-subgroup-" +
                                                          subGroup.key,
                                                        staticClass:
                                                          "d-flex flex-row dbox-wrapper project-subgroup-wrapper"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "w-100 dbox-left-side"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "top-row"
                                                              },
                                                              [
                                                                _c("div", {
                                                                  staticClass:
                                                                    "data-items group-title"
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "data-items"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        class: [
                                                                          "notification-preview",
                                                                          "deliverable-subgroup-preview",
                                                                          subGroup.unread ===
                                                                          0
                                                                            ? "read-notification"
                                                                            : ""
                                                                        ]
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "b-tooltip",
                                                                                rawName:
                                                                                  "v-b-tooltip.hover",
                                                                                modifiers: {
                                                                                  hover: true
                                                                                }
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "notification-icon-wrapper  cursor-pointer",
                                                                            attrs: {
                                                                              title: _vm.getMarkAllDeliverableSubgroupTooltip(
                                                                                subGroup
                                                                              )
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.markAllDeliverableSubgroupNotifsRead(
                                                                                  groupKey,
                                                                                  subGroup.deliverableId,
                                                                                  subGroup.unread
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "deliverable-subgroup-title-icon",
                                                                                attrs: {
                                                                                  src: _vm.getDeliverableSubgroupHeaderIcon(
                                                                                    subGroup
                                                                                  )
                                                                                }
                                                                              }
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "b-tooltip",
                                                                                rawName:
                                                                                  "v-b-tooltip.hover",
                                                                                modifiers: {
                                                                                  hover: true
                                                                                }
                                                                              }
                                                                            ],
                                                                            class: [
                                                                              "details deliverable-subgroup-title",
                                                                              subGroup.deleted
                                                                                ? "text-muted"
                                                                                : "cursor-pointer"
                                                                            ],
                                                                            attrs: {
                                                                              title: subGroup.deleted
                                                                                ? "Deliverable deleted"
                                                                                : "Open deliverable"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                !subGroup.deleted &&
                                                                                  _vm.openDeliverableFromProjectSubgroup(
                                                                                    groupKey,
                                                                                    subGroup.deliverableId
                                                                                  )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "fw-bold"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    subGroup.title
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "b-collapse",
                                                              {
                                                                attrs: {
                                                                  id:
                                                                    "notification-group-collapse-" +
                                                                    subGroup.key,
                                                                  visible: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "ul",
                                                                  {
                                                                    staticClass:
                                                                      "list-unstyled notification-list-single-column"
                                                                  },
                                                                  _vm._l(
                                                                    subGroup.alerts,
                                                                    function(
                                                                      alert,
                                                                      index
                                                                    ) {
                                                                      return _c(
                                                                        "li",
                                                                        {
                                                                          key:
                                                                            "alert-" +
                                                                            subGroup.key +
                                                                            "-" +
                                                                            index,
                                                                          staticClass:
                                                                            "group-alert-item notification-single-row",
                                                                          class:
                                                                            alert.status ==
                                                                            0
                                                                              ? "unread-notification"
                                                                              : "read-notification",
                                                                          attrs: {
                                                                            id:
                                                                              "notification-alert-" +
                                                                              alert.id
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "placeholder-n"
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "notification-info-wrapper"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  directives: [
                                                                                    {
                                                                                      name:
                                                                                        "b-tooltip",
                                                                                      rawName:
                                                                                        "v-b-tooltip.hover",
                                                                                      modifiers: {
                                                                                        hover: true
                                                                                      }
                                                                                    }
                                                                                  ],
                                                                                  staticClass:
                                                                                    "notification-icon-wrapper cursor-pointer",
                                                                                  attrs: {
                                                                                    title:
                                                                                      alert.status ==
                                                                                      0
                                                                                        ? "Mark as read"
                                                                                        : "Read"
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      $event.stopPropagation()
                                                                                      return _vm.markAlertReadOnly(
                                                                                        alert,
                                                                                        groupKey
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "img",
                                                                                    {
                                                                                      staticClass:
                                                                                        "notification-icon",
                                                                                      attrs: {
                                                                                        src: _vm.getDeliverableIconSrc(
                                                                                          alert.status
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              alert.status ==
                                                                              0
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "alert-status"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "i",
                                                                                        {
                                                                                          directives: [
                                                                                            {
                                                                                              name:
                                                                                                "b-tooltip",
                                                                                              rawName:
                                                                                                "v-b-tooltip.hover",
                                                                                              modifiers: {
                                                                                                hover: true
                                                                                              }
                                                                                            }
                                                                                          ],
                                                                                          staticClass:
                                                                                            "fas fa-circle",
                                                                                          class:
                                                                                            alert.status ==
                                                                                            0
                                                                                              ? "text-primary"
                                                                                              : "text-primary",
                                                                                          attrs: {
                                                                                            title:
                                                                                              alert.status ==
                                                                                              0
                                                                                                ? "Unread"
                                                                                                : "Read"
                                                                                          }
                                                                                        }
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  directives: [
                                                                                    {
                                                                                      name:
                                                                                        "b-tooltip",
                                                                                      rawName:
                                                                                        "v-b-tooltip.hover",
                                                                                      modifiers: {
                                                                                        hover: true
                                                                                      }
                                                                                    }
                                                                                  ],
                                                                                  staticClass:
                                                                                    "details cursor-pointer",
                                                                                  attrs: {
                                                                                    title:
                                                                                      "View detail"
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      $event.stopPropagation()
                                                                                      return _vm.setAlert(
                                                                                        alert,
                                                                                        groupKey
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "alert__name cursor-pointer fw-bold"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          alert.title
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "br"
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "notification-sender"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "fw-bold"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              alert.sender
                                                                                            ) +
                                                                                              " @ " +
                                                                                              _vm._s(
                                                                                                _vm.getLocalAlertTime(
                                                                                                  alert.created_at
                                                                                                )
                                                                                              )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "br"
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "note-message",
                                                                                      domProps: {
                                                                                        innerHTML: _vm._s(
                                                                                          _vm.processMessage(
                                                                                            alert.message
                                                                                          )
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                ),
                                                                _vm._v(" "),
                                                                subGroup.hasMore &&
                                                                subGroup.total >
                                                                  5
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "text-center py-3"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "b-button",
                                                                          {
                                                                            staticClass:
                                                                              "load-more-btn",
                                                                            attrs: {
                                                                              variant:
                                                                                "outline-secondary",
                                                                              size:
                                                                                "sm",
                                                                              disabled:
                                                                                _vm
                                                                                  .projectSubgroupLoading[
                                                                                  subGroup
                                                                                    .key
                                                                                ]
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.loadMoreProjectSubgroup(
                                                                                  groupKey,
                                                                                  subGroup.deliverableId,
                                                                                  subGroup.key
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm
                                                                              .projectSubgroupLoading[
                                                                              subGroup
                                                                                .key
                                                                            ]
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                                                Loading...\n                                                            "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                                                Load More\n                                                            "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          : _c("div", [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "list-unstyled notification-list-single-column"
                                                },
                                                _vm._l(
                                                  _vm
                                                    .getGroupAlerts(groupKey)
                                                    .slice(1),
                                                  function(alert, index) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        key: "alert-" + index,
                                                        staticClass:
                                                          "group-alert-item notification-single-row",
                                                        class:
                                                          alert.status == 0
                                                            ? "unread-notification"
                                                            : "read-notification",
                                                        attrs: {
                                                          id:
                                                            "notification-alert-" +
                                                            alert.id
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "placeholder-n"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "notification-info-wrapper"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "b-tooltip",
                                                                    rawName:
                                                                      "v-b-tooltip.hover",
                                                                    modifiers: {
                                                                      hover: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "notification-icon-wrapper cursor-pointer",
                                                                attrs: {
                                                                  title:
                                                                    alert.status ==
                                                                    0
                                                                      ? "Mark as read"
                                                                      : "Read"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.markAlertReadOnly(
                                                                      alert,
                                                                      groupKey
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm
                                                                  .currentFilters
                                                                  .group_by ===
                                                                "deliverable"
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "notification-icon",
                                                                      attrs: {
                                                                        src: _vm.getDeliverableIconSrc(
                                                                          alert.status
                                                                        )
                                                                      }
                                                                    })
                                                                  : _vm
                                                                      .currentFilters
                                                                      .group_by ===
                                                                    "global_alert"
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "notification-icon",
                                                                      attrs: {
                                                                        src: require("@/csmworkflow/img/bell-regular.svg")
                                                                      }
                                                                    })
                                                                  : _vm
                                                                      .currentFilters
                                                                      .group_by ===
                                                                    "project"
                                                                  ? _c("i", {
                                                                      class: [
                                                                        "fas",
                                                                        "fa-folder",
                                                                        "fa-fw",
                                                                        "notification-icon-fa"
                                                                      ],
                                                                      style: {
                                                                        color: _vm.getProjectIconColor(
                                                                          alert.status
                                                                        )
                                                                      }
                                                                    })
                                                                  : _vm._e()
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            alert.status == 0
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "alert-status"
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "b-tooltip",
                                                                          rawName:
                                                                            "v-b-tooltip.hover",
                                                                          modifiers: {
                                                                            hover: true
                                                                          }
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "fas fa-circle",
                                                                      class:
                                                                        alert.status ==
                                                                        0
                                                                          ? "text-primary"
                                                                          : "text-primary",
                                                                      attrs: {
                                                                        title:
                                                                          alert.status ==
                                                                          0
                                                                            ? "Unread"
                                                                            : "Read"
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "p",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "b-tooltip",
                                                                    rawName:
                                                                      "v-b-tooltip.hover",
                                                                    modifiers: {
                                                                      hover: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "details cursor-pointer",
                                                                attrs: {
                                                                  title:
                                                                    "View detail"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.setAlert(
                                                                      alert,
                                                                      groupKey
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "alert__name cursor-pointer fw-bold"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        alert.title
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("br"),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "notification-sender"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "fw-bold"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            alert.sender
                                                                          ) +
                                                                            " @ " +
                                                                            _vm._s(
                                                                              _vm.getLocalAlertTime(
                                                                                alert.created_at
                                                                              )
                                                                            )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("br"),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "note-message",
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      _vm.processMessage(
                                                                        alert.message
                                                                      )
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]),
                                        _vm._v(" "),
                                        _vm.currentFilters.group_by !==
                                          "project" &&
                                        _vm.groupHasMore[groupKey] &&
                                        _vm.getGroupTotal(groupKey) > 5
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "text-center py-3"
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "load-more-btn",
                                                    attrs: {
                                                      variant:
                                                        "outline-secondary",
                                                      size: "sm",
                                                      disabled:
                                                        _vm.groupLoadingMore[
                                                          groupKey
                                                        ]
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.loadMoreGroup(
                                                          groupKey
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm.groupLoadingMore[
                                                      groupKey
                                                    ]
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                                                Loading...\n                                            "
                                                          )
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            "\n                                                Load More\n                                            "
                                                          )
                                                        ])
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "dbox-right-side" },
                                  [
                                    _c("CollapseNotificationBtn", {
                                      attrs: {
                                        notifications: _vm.getGroupAlerts(
                                          groupKey
                                        ),
                                        groupKey: groupKey,
                                        expandAll: _vm.expandAllGroups,
                                        totalCount: _vm.getCollapseTotalCount(
                                          groupKey
                                        ),
                                        unreadTotal: _vm.getCollapseUnreadTotal(
                                          groupKey
                                        ),
                                        "has-header-preview": false
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center mb-3 group-header-row"
                                },
                                [
                                  _c(
                                    "h4",
                                    { staticClass: "group-header mb-0" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$moment(groupKey)
                                            .format("MMMM D, YYYY")
                                        ) +
                                          "\n                                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.hasUnreadInGroup(group)
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass: "btn btn-theme",
                                          attrs: { variant: "theme" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.makeGroupAlertsRead(
                                                group
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                      Mark All as Read\n                                  "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                {
                                  staticClass: "list-unstyled no-grouping-list"
                                },
                                _vm._l(_vm.getDateGroupAlerts(group), function(
                                  alert,
                                  index
                                ) {
                                  return _c(
                                    "li",
                                    {
                                      key: "alert-" + index,
                                      staticClass:
                                        "no-group-alert-item notification-single-row",
                                      class:
                                        alert.status == 0
                                          ? "unread-notification"
                                          : "read-notification",
                                      attrs: {
                                        id: "notification-alert-" + alert.id
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "notification-info-wrapper"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true }
                                                }
                                              ],
                                              staticClass:
                                                "notification-icon-wrapper cursor-pointer",
                                              attrs: {
                                                title:
                                                  alert.status == 0
                                                    ? "Mark as read"
                                                    : "Read"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.markAlertReadOnly(
                                                    alert
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              alert.alert_model ===
                                                "deliverable" ||
                                              alert.grouped_model ===
                                                "deliverable" ||
                                              alert.alert_model === "task"
                                                ? _c("img", {
                                                    staticClass:
                                                      "notification-icon",
                                                    attrs: {
                                                      src: _vm.getDeliverableIconSrc(
                                                        alert.status
                                                      )
                                                    }
                                                  })
                                                : alert.alert_model ===
                                                    "project" ||
                                                  alert.grouped_model ===
                                                    "project"
                                                ? _c("i", {
                                                    class: [
                                                      "fas",
                                                      "fa-folder",
                                                      "fa-fw",
                                                      "notification-icon-fa"
                                                    ],
                                                    style: {
                                                      color: _vm.getProjectIconColor(
                                                        alert.status
                                                      )
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "notification-icon",
                                                    attrs: {
                                                      src: require("@/csmworkflow/img/bell-regular.svg")
                                                    }
                                                  })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true }
                                                }
                                              ],
                                              staticClass:
                                                "details cursor-pointer",
                                              attrs: { title: "View detail" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.setAlert(alert)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "alert__name cursor-pointer fw-bold"
                                                },
                                                [_vm._v(_vm._s(alert.title))]
                                              ),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "notification-sender"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "fw-bold" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(alert.sender) +
                                                          " @ " +
                                                          _vm._s(
                                                            _vm.getLocalAlertTime(
                                                              alert.created_at
                                                            )
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "note-message",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.processMessage(
                                                      alert.message
                                                    )
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ])
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("pagination", {
                  attrs: { data: _vm.userAlerts, limit: 5 },
                  on: { "pagination-change-page": _vm.onChangePage }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "hide-footer": "",
            id: "editDeliverableModal",
            title: "Edit Deliverable"
          },
          on: {
            hide: _vm.editDeliverableModalHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditModal", {
            ref: "refEditModal",
            attrs: {
              allContacts: _vm.allContacts,
              namespace: _vm.namespace,
              tabIndex: _vm.tabIndex
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-social-deliverable",
          attrs: {
            size: "lg",
            "hide-footer": "",
            id: "editSocialModal",
            title: "Edit Social Deliverable"
          },
          on: {
            hide: _vm.editSocialModalHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditSocialModal", {
            ref: "refEditSocialModal",
            attrs: { namespace: _vm.namespace, tabIndex: _vm.tabIndex }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-footer": "",
            id: "editOrganicSocialMediaPlanModal",
            title: "Edit Organic Social Media Plan"
          },
          on: {
            hide: _vm.editOrganicSocialModalPlanHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditOrganicSocialMediaPlanModal", {
            ref: "refEditOrganicSocialMediaPlanModal",
            attrs: { tabIndex: _vm.tabIndex, namespace: _vm.namespace }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "media-call-icon pointer-default" }, [
      _c("img", {
        attrs: {
          width: "30px",
          src: require("@/csmworkflow/img/bell-module.svg")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "float-right" }, [
      _c("i", { staticClass: "far fa-edit text-primary" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "float-right" }, [
      _c("i", { staticClass: "fas fa-plus-circle text-primary" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data-items group-title" }, [
      _c(
        "h3",
        {
          staticClass: "group-header-title mb-0",
          staticStyle: { cursor: "default" }
        },
        [
          _vm._v(
            "\n                                            Important Notifications\n                                        "
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-flex justify-content-between align-items-center mb-3 group-header-row"
      },
      [
        _c("h4", { staticClass: "group-header mb-0" }, [
          _vm._v("Important Notifications")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }